import React, { useState, useEffect } from 'react';

import { doc, getDoc } from 'firebase/firestore';
import { db, PageIDs } from '../../config';

import Modal from "./Modal";
import parse from 'html-react-parser';

const Page = ( { setShowPage, name} ) => {

    const [pageContent, setPageContent] = useState();

    const getPage = async (name) => {
        const page = PageIDs?.find(page => page.name === name);
        if (!page) return;
        const docRef = doc(db, "pagecontent", page.id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setPageContent(docSnap.data());
        } else {
            console.log("can't get page content", name);
        }
    }

    useEffect(() => {
        setPageContent();
        //get page info
        if (!name) return;
        getPage(name);
        return () => {
            setPageContent();
        };
      }, [name])

      if (!pageContent) return (
        <></>
      )

    
    return (

        <Modal 
            align='top' 
            back 
            title={pageContent.title} 
            onConfirm={()=>setShowPage(false)}
            onCancel={()=>setShowPage(false)}
            >
        
            {pageContent.text && parse(pageContent.text)} 

        </Modal>

    );

}

export default Page ;